module.exports = __webpack_public_path__ + "img/svg/faq-separator.152bc82d108873593b106d4cdf32ca9c.svg";